<template>
  <div id="component-name">
    Hej, jag är en ny komponent.
    <p>{{ this.$store.state.count }}</p>
    <button @click="increment">increment</button>
    <button @click="decrement">decrement</button>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  data () {
    return {
      msg: 'Empty component'
    }
  },
  props: [],
  computed: {},
  methods: {
    increment () {
      this.$store.commit('increment')
    },
    decrement () {
      this.$store.commit('decrement')
    }
  },
  mounted () {
  },
  components: {}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Empty.vue